export const ALL_EQUIPMENT_CATEGORY_VALUE = '__all_equipment__';

export const ADD_FORM_NAME_LABEL = '+ Add form name';

type FormNameRecord = {
    id?: string | null;
    name?: string | null;
    formType?: string | null;
    inspectionForm?: boolean | null;
    dailyServiceLogForm?: boolean | null;
    pmServiceScheduleForm?: boolean | null;
};

function matchesFormType(form: FormNameRecord, formType: string): boolean {
    if (form.formType) return form.formType === formType;
    if (formType === 'dailyService') return Boolean(form.dailyServiceLogForm);
    if (formType === 'inspection') return Boolean(form.inspectionForm);
    if (formType === 'pmService') return Boolean(form.pmServiceScheduleForm);
    return false;
}

export function compareAlpha(a: string, b: string): number {
    return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
}

export function findDuplicateFormName(
    name: string,
    forms: FormNameRecord[],
    formType: string,
    excludeFormId?: string | null,
): { id: string; name: string } | null {
    const trimmed = name.trim().toLowerCase();
    if (!trimmed) return null;
    const match = forms.find((form) => {
        if (!form.id || form.id === excludeFormId) return false;
        if (!matchesFormType(form, formType)) return false;
        return (form.name || '').trim().toLowerCase() === trimmed;
    });
    return match?.id ? { id: match.id, name: match.name || name.trim() } : null;
}

export function duplicateFormNameMessage(enteredName: string): string {
    return `"${enteredName.trim()}" is already used. Enter a new form name.`;
}

export function uniqueSortedFormNameOptions(
    forms: FormNameRecord[],
    formType: string,
): Array<{ value: string; label: string }> {
    const names = new Set<string>();
    for (const form of forms) {
        if (!matchesFormType(form, formType)) continue;
        const name = form.name?.trim();
        if (name) names.add(name);
    }
    return [...names].sort(compareAlpha).map((name) => ({ value: name, label: name }));
}

export function sortedEquipmentCategoryOptions(
    categories: Array<{ name?: string | null }>,
): Array<{ value: string; label: string }> {
    return [...categories]
        .map((category) => category.name?.trim() || '')
        .filter(Boolean)
        .sort(compareAlpha)
        .map((name) => ({ value: name, label: name }));
}

export function equipmentCategorySelectValue(storedName: string): string {
    return storedName.trim() ? storedName : ALL_EQUIPMENT_CATEGORY_VALUE;
}

export function equipmentCategoryStoredName(selectValue: string): string {
    return selectValue === ALL_EQUIPMENT_CATEGORY_VALUE ? '' : selectValue;
}
